import { apiSubmitTicket, apiTicketCommentUpdate } from '@/resource'
const editorContentDefault = {
  html: '',
  text: '',
  quill: {},
}
export default {
  data() {
    return {
      subject: '',
      uploadFileList: [],
      editorContent: { ...editorContentDefault },
    }
  },
  methods: {
    resetInputField() {
      this.uploadFileList = []
      this.editorContent = editorContentDefault
      this.subject = ''
    },
    onClose(refreshList = false) {
      this.$emit('onTicketDialogClose', refreshList)
      this.resetInputField()
    },
    popMessage(msg, type) {
      this.$message({
        message: this.$t(`supportTickets.${msg}`),
        type: type,
      })
    },
    onSubmit(type) {
      const formData = new FormData()

      // const message = this.editorContent.html
      const message = this.editorContent.text
      const fileData = this.uploadFileList

      formData.append('message', message)

      if (fileData.length > 0) {
        fileData.forEach((file, i) => {
          formData.append('file_data', file.raw)
        })
      }

      if (type === 'update') {
        const ticketId = this.data.id
        if (!ticketId) {
          return
        }
        formData.append('ticket_id', ticketId)
      }

      if (type === 'new') {
        const subject = this.subject
        if (!subject) {
          this.popMessage('subjectFieldRequired', 'error')
          return
        }
        formData.append('subject', subject)
      }

      if (!message) {
        this.popMessage(type === 'new' ? 'contentFieldRequired' : 'postReplyRequired', 'error')
        return
      }

      if (type === 'update') {
        this.submitTicketComment(formData)
      }

      if (type === 'new') {
        this.submitNewTicket(formData)
      }
    },
    submitTicketComment(formData) {
      apiTicketCommentUpdate(formData).then(resp => {
        if (resp.data.code === 0) {
          this.fetchComments()
          this.resetInputField()
          this.onClose(true)
        }
      })
    },
    submitNewTicket(formData) {
      apiSubmitTicket(formData).then(resp => {
        if (resp.data.code === 0) {
          this.popMessage('successMsg', 'success')
          this.onClose(true)
        }
      })
    },
  },
}
